import { Directive, ElementRef } from '@angular/core';
import { FocusableOption, FocusOrigin } from '@angular/cdk/a11y';

@Directive({
  selector: '[libListButton]',
})
export class ListButtonDirective implements FocusableOption {
  constructor(public readonly elementRef: ElementRef<HTMLButtonElement>) {}

  disabled = false;

  focus(origin?: FocusOrigin): void {
    this.elementRef.nativeElement.focus();
  }

  getLabel(): string {
    return this.elementRef.nativeElement.innerText;
  }
}
